import React from "react";
import MobileStepper from "../stepperMobile";
import { MOBILE_PAGES } from ".";

export function MobilePage() {
  return (
    <React.Fragment>
      <MobileStepper pages={MOBILE_PAGES} />
    </React.Fragment>
  );
}
